export const messages = {
  en: {
    downloadTempFile: {
      title: 'Download Center',
      refresh: 'Refresh',
      name: 'Name',
      fileType: 'File Type',
      downloader: 'Downloader',
      downloadTime: 'Download Time',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      download: 'Download',
      delete: 'Delete',
      downloadFailed: 'Download failed'
    },
    deleteDownloadTempFile: {
      confirmTitle: 'Please confirm your operation',
      confirmText: 'Confirm to delete the file?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    downloadTempFile: {
      title: '下载中心',
      refresh: '刷新',
      name: '名称',
      fileType: '文件类型',
      downloader: '下载人',
      downloadTime: '下载时间',
      status: '状态',
      remark: '备注',
      operation: '操作',
      download: '下载',
      delete: '删除',
      downloadFailed: '下载失败'
    },
    deleteDownloadTempFile: {
      confirmTitle: '请确认您的操作',
      confirmText: '确定删除文件？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}